import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import Header from "../Header/Header";
import MainScreen from "./MainScreen";
import PrivacyPolicy from "../Authentication/PrivacyPolicy";
import Levels from "../levels/Levels";

import A1 from "../levels/A1/A1";
import A2 from "../levels/A2/A2";
import B1 from "../levels/B1/B1";
import B2 from "../levels/B2/B2";
import C1 from "../levels/C1/C1";
import C2 from "../levels/C2/C2";

import A1Basic from "../levels/A1/A1Basic/A1Basic";
import Alphabet from "../levels/A1/A1Basic/Alphabet/Alphabet";
import Numbers from "../levels/A1/A1Basic/Numbers/Numbers";
import Colors from "../levels/A1/A1Basic/Colors/Colors";
import Weather from "../levels/A1/A1Basic/Weather/Weather";
import Animals from "../levels/A1/A1Basic/Animals/Animals";
import Birds from "../levels/A1/A1Basic/Birds/Birds";
import Body from "../levels/A1/A1Basic/Body/Body";
import Cloth from "../levels/A1/A1Basic/Cloth/Cloth";
import Days from "../levels/A1/A1Basic/Days/Days";
import Direction from "../levels/A1/A1Basic/Direction/Direction";
import Drinks from "../levels/A1/A1Basic/Drinks/Drinks";
import Emotion from "../levels/A1/A1Basic/Emotion/Emotion";
import Family from "../levels/A1/A1Basic/Family/Family";
import Food from "../levels/A1/A1Basic/Food/Food";
import Fruits from "../levels/A1/A1Basic/Fruits/Fruits";
import Furnitures from "../levels/A1/A1Basic/Furniture/Furnitures";
import Hobbies from "../levels/A1/A1Basic/Hobbies/Hobbies";
import Months from "../levels/A1/A1Basic/Months/Months";
import Profession from "../levels/A1/A1Basic/Profession/Profession";
import Seasons from "../levels/A1/A1Basic/Seasons/Seasons";
import Sports from "../levels/A1/A1Basic/Sports/Sports";
import Time from "../levels/A1/A1Basic/Time/Time";
import Transport from "../levels/A1/A1Basic/Transport/Transport";
import Vegetables from "../levels/A1/A1Basic/Vegetables/Vegetables";

import A1Conversations from "../levels/A1/A1Conversation/A1Conversations";
import A1Grammar from "../levels/A1/A1Grammar/A1Grammar";
import Nouns from "../levels/A1/A1Grammar/Nouns";
import A1Stories from "../levels/A1/A1Stories/A1Stories";

import GermanAppQr from "../GermanApp/GermanAppQr";
import TermsOfService from "../Authentication/TermsOfService";

const MainStack: React.FC = () => {
  const [showMain, setShowMain] = useState(false);

  return (
    <div className="mainWrapper">
      <Header />

      <Routes>
        <Route
          path="/"
          element={<MainScreen onStart={() => setShowMain(true)} />}
        />

        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />

        <Route path="/levels" element={<Levels />} />

        <Route path="/levels/a1" element={<A1 />} />
        <Route path="/levels/a1/basic" element={<A1Basic />} />
        <Route path="/levels/a1/basic/alphabet" element={<Alphabet />} />
        <Route path="/levels/a1/basic/numbers" element={<Numbers />} />
        <Route path="/levels/a1/basic/colors" element={<Colors />} />
        <Route path="/levels/a1/basic/weather" element={<Weather />} />
        <Route path="/levels/a1/basic/animals" element={<Animals />} />
        <Route path="/levels/a1/basic/birds" element={<Birds />} />
        <Route path="/levels/a1/basic/body" element={<Body />} />
        <Route path="/levels/a1/basic/cloths" element={<Cloth />} />
        <Route path="/levels/a1/basic/days" element={<Days />} />
        <Route path="/levels/a1/basic/direction" element={<Direction />} />
        <Route path="/levels/a1/basic/drinks" element={<Drinks />} />
        <Route path="/levels/a1/basic/emotion" element={<Emotion />} />
        <Route path="/levels/a1/basic/family" element={<Family />} />
        <Route path="/levels/a1/basic/food" element={<Food />} />
        <Route path="/levels/a1/basic/fruits" element={<Fruits />} />
        <Route path="/levels/a1/basic/furnitures" element={<Furnitures />} />
        <Route path="/levels/a1/basic/hobbies" element={<Hobbies />} />
        <Route path="/levels/a1/basic/months" element={<Months />} />
        <Route path="/levels/a1/basic/profession" element={<Profession />} />
        <Route path="/levels/a1/basic/seasons" element={<Seasons />} />
        <Route path="/levels/a1/basic/sports" element={<Sports />} />
        <Route path="/levels/a1/basic/time" element={<Time />} />
        <Route path="/levels/a1/basic/transport" element={<Transport />} />
        <Route path="/levels/a1/basic/vegetables" element={<Vegetables />} />

        <Route
          path="/levels/a1/a1conversations"
          element={<A1Conversations />}
        />
        <Route path="/levels/a1/a1grammar" element={<A1Grammar />} />
        <Route path="/levels/a1/a1grammar/nouns" element={<Nouns />} />
        <Route path="/levels/a1/a1stories" element={<A1Stories />} />

        <Route path="/levels/a2" element={<A2 />} />
        <Route path="/levels/b1" element={<B1 />} />
        <Route path="/levels/b2" element={<B2 />} />
        <Route path="/levels/c1" element={<C1 />} />
        <Route path="/levels/c2" element={<C2 />} />

        {/* Standalone QR Page (optional) */}
        <Route
          path="/german-app"
          element={
            <GermanAppQr
              iosStoreUrl="https://apps.apple.com/de/app/learn-german-a1-c2/id6746383285?l=en-GB"
              androidStoreUrl="https://play.google.com/store/apps/details?id=com.kugathaj.deutsch"
              title="Download the App"
              subtitle="Scan or tap to get started"
              compact
            />
          }
        />
      </Routes>
    </div>
  );
};

export default MainStack;
